module.exports = __webpack_public_path__ + "img/vouchIntroduce.1eadc22e.png";